import { apiRequest } from "./api";

export async function createCaseIssue(
  data: CreateCaseIssueDto,
  companyUuid?: string
) {
  let query = "?";
  if (companyUuid) query += `companyUuid=${companyUuid}`;

  const response = await apiRequest<ReadCaseIssueDto>(
    "post",
    `/caseIssues/create${query}`,
    data
  );
  return response;
}

export async function getCaseIssueByCase(
  caseData: string,
  companyUuid?: string
) {
  let query = `?case=${caseData}`;
  if (companyUuid) query += `&companyUuid=${companyUuid}`;

  if (caseData) {
    const response = await apiRequest<ReadCaseIssueDto>(
      "get",
      `/caseIssues/find-by-case${query}`
    );
    return response;
  }
}

export async function getCaseIssueByUuid(uuid: string, companyUuid?: string) {
  let query = `?uuid=${uuid}`;
  if (companyUuid) query += `&companyUuid=${companyUuid}`;

  if (uuid) {
    const response = await apiRequest<ReadCaseIssueDto>(
      "get",
      `/caseIssues/find-by-uuid${query}`
    );
    return response;
  }
}

export async function selectCaseIssues(companyUuid?: string) {
  let query = "";
  if (companyUuid) query = `?companyUuid=${companyUuid}`;

  const response = await apiRequest<SelectCaseIssueDto[]>(
    "get",
    `/caseIssues/select${query}`
  );
  return response;
}

export async function getCaseIssuesListAndSearch(
  page: number,
  itemsPerPage: number,
  search?: string,
  active?: string,
  companyUuid?: string
): Promise<ListCaseIssueDto> {
  let query = "?";
  query += page ? `page=${page}&` : "";
  query += itemsPerPage ? `itemsPerPage=${itemsPerPage}&` : "";
  query += search ? `search=${search}&` : "";
  query += active ? `active=${active}` : "";
  if (companyUuid) query += `&companyUuid=${companyUuid}`;

  return await apiRequest<ListCaseIssueDto>("get", `/caseIssues/list${query}`);
}

export async function updateCaseIssue(
  uuid: string,
  data: UpdateCaseIssueDto,
  companyUuid?: string
) {
  let query = `?uuid=${uuid}`;
  if (companyUuid) query += `&companyUuid=${companyUuid}`;
  if (uuid) {
    const response = await apiRequest<any>(
      "put",
      `/caseIssues/update${query}`,
      data
    );
    return response;
  }
}

export async function deleteCaseIssue(uuid: string, companyUuid?: string) {
  let query = `?uuid=${uuid}`;
  if (companyUuid) query += `&companyUuid=${companyUuid}`;

  if (uuid) {
    const response = await apiRequest<any>(
      "delete",
      `/caseIssues/soft-delete${query}`
    );
    return response;
  }
}
